// extracted by mini-css-extract-plugin
export default {"groupPrelimVotesContainer":"D7BoBxSgpAOXfxBn3vnm"};